
import React, { useEffect, useState, useCallback, useMemo, useRef, useImperativeHandle, useReducer } from 'react'
import { useSelector } from 'react-redux'
import { useAppDispatch } from 'store'
import { createSelector } from '@reduxjs/toolkit'
import { Form, useFormikContext } from 'formik'
import { IxField, IxEmptyField } from 'components/forms/field'

import { IxFloatingButtons } from 'components/floating-buttons'
import { useIxOnScreen } from 'hooks/use-on-screen'

import { BaseIcons } from 'enums/base-icons'

import _ from 'lodash'
import { prepareNotification } from 'helpers/prepare-notifications'

import { Button } from 'devextreme-react/button'
import ResponsiveBox, { Row, Col, Item, Location } from 'devextreme-react/responsive-box'
import LoadPanel from 'devextreme-react/load-panel'
import MultiView, { Item as MVItem } from 'devextreme-react/multi-view'

import { useTranslation } from 'react-i18next'

import { RootState } from 'slices'
import { rightsSelector } from 'slices/rights'
import { setNotificationsByKeyThunk, removeNotificationsByKeyThunk } from 'slices/notifications'
import { setActions } from 'slices/action-panel'
import {
    loadUserParamsProcessPrinterSetupParamInterface,
    startProcessPrinterSetupParamInterface,
    resetstartProcessPrinterSetupParamInterfaceError,
    resetloadUserParamsProcessPrinterSetupParamInterfaceError,
} from 'slices/process-printer-setup-param-interface-slice.gen'
import { setFormModes, selectionBannerChanged, selectionChanged, setSelection, setSelectedItem, updateReloadedItem, setDirty, switchTab, closePopup, closeDynamicPopup, selectionBannerLookupDataChanged } from 'slices/pages-slice'  // eslint-disable-line
import { showCPopup } from 'slices/confirmation-popup-slice'
import { useSetFieldValueFromLookup } from 'hooks/lookup-field-hooks/use-set-field-value-from-lookup'
import { settingsMenuSelector } from 'slices/ui'
import { useUserSettingsUpdate } from 'hooks'
import { SettingType } from 'helpers/setting-type-enum'
import { Settings } from 'helpers/settings-enum'

import { useIxJsonSchema } from 'hooks/use-json-schema'

import { keyboardControl } from 'helpers'
import { useIxFocusElement } from 'hooks'

import { IxModuleRights } from 'enums/rights-enum'

import { FormMode } from 'helpers/form-mode-enum'
import { shallowEqual } from 'helpers/shallow-equal'
import { setJobNotification } from 'helpers/set-job-notification'
import { datesToIso } from 'helpers/fix-dates'
import { useIxFetchActionsMenu } from 'hooks/use-fetch-actions-menu'

import { BaseForm, Spinner, ValidationSummary, FormGroup  } from 'components'

import { useIxLookupContext } from 'contexts/lookup-context'
import { IxLookupProvider } from 'contexts/lookup-context'
import {
    IxPrnSrvcPrinterLookup,
} from 'components/forms/lookups'

import {
    CheckBoxInput,
    NumberInput,
    SelectInput,
    TextInput,
} from 'components/forms'



import { IxkeinePrinterSetupExeResultAction, ixkeinePrinterSetupExeResultActionToOpts } from 'enums/ix-web-prn-srvc.gen/ixkeine-printer-setup-exe-result-action-enum.gen'

import { setMaxLabelWidth } from 'helpers/set-max-label-width'

const _pageType = 'subpage'

// constants used when no page name is provided
const _processPrinterSetupParamInterface = {}
const _formMode = FormMode.Create
const _tabProps = { initialvalues: {} }


const _expandedFormGroupsKey = 'IxProcessPrinterSetupParamInterfaceForm'

// this is used for i18next-scanner to pick up labels
const _t = (s: string) => s
export const labelsMap: {[k: string]: string} = {
    'Type': _t('processprintersetupparaminterface:field.Type'),
    'UserId': _t('processprintersetupparaminterface:field.UserId'),
    'ReportId': _t('processprintersetupparaminterface:field.ReportListId'),
    'DoDelete': _t('processprintersetupparaminterface:field.DoDelete'),
    'ResultAction': _t('processprintersetupparaminterface:field.ResultAction'),
    'PrnSrvcRelId': _t('processprintersetupparaminterface:field.PrnSrvcRelId'),
    'StdBinPrSettId': _t('processprintersetupparaminterface:field.StdBinPrSettId'),
    'Bin1PrSettId': _t('processprintersetupparaminterface:field.Bin1PrSettId'),
    'Bin2PrSettId': _t('processprintersetupparaminterface:field.Bin2PrSettId'),
    'DuplexPrSettId': _t('processprintersetupparaminterface:field.DuplexPrSettId'),
    'PrnSrvcPathId': _t('processprintersetupparaminterface:field.PrnSrvcPathRelId'),
    'RelativePath': _t('processprintersetupparaminterface:field.RelativePath'),
}

const dateFields: string[] = [
]

export const _initialValues: any = {
    "HDR_ID": 0,
    "Type": null,
    "UserId": null,
    "ReportId": null,
    "DoDelete": false,
    "ResultAction": null,
    "PrnSrvcRelId": null,
    "StdBinPrSettId": null,
    "Bin1PrSettId": null,
    "Bin2PrSettId": null,
    "DuplexPrSettId": null,
    "PrnSrvcPathId": null,
    "RelativePath": ''
}

const genInitialValues = (val: any = {}) => {
    let initialValues = {
        ..._initialValues,
    }

    initialValues = val ? { ...initialValues, ...val } : initialValues


    return initialValues
}


const visInitialState = {
    0: {},
    1: {},
    2: {},
    3: {},
}

const visReducer = (state: any, action: any) => {
    switch(action.type) {
        case 'show':
            return { ...state, [action.groupId]: { ...state[action.groupId], [action.fieldName]: true } }
        case 'hide':
            return { ...state, [action.groupId]: { ...state[action.groupId], [action.fieldName]: false } }
    }
}

const isGroupVisible = (fieldsVis: any[], index: number) => {
    return (Object.keys(fieldsVis[index]).length === 0) || (Object.values(fieldsVis[index]).indexOf(true) >= 0)
}

const lookupFields: string[] = [
    'PrnSrvcRelId',
]

export const FocusHandler = ({ itemsData, lastFocusedElement }: any) => {
    const { values } = useFormikContext<typeof _initialValues>()

    useIxFocusElement(values, itemsData, lastFocusedElement, document.getElementById('processPrinterSetupParamInterface-form'))

    return null
}

interface IAutoUpdateForm {
    pageName: string,
    formMode: FormMode,
    active: boolean,
    resetMode?: () => void
    setInitialValues: (values: any) => void,
    valuesToSet?: any
}

// exported for testing
export const AutoUpdateForm = ({ pageName, formMode, active=true, resetMode, setInitialValues, valuesToSet = null }: IAutoUpdateForm) => {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const { validateForm, values, setValues, errors, touched, dirty, resetForm, setFieldValue, initialValues} = useFormikContext<typeof _initialValues>()
    const { getFieldValue } = useIxLookupContext()  // eslint-disable-line @typescript-eslint/no-unused-vars
    const _prevValues = useRef<any>(values)
    const dispatch = useAppDispatch()
    const { t, i18n } = useTranslation()

    const waitingForFormReset = useRef(false)
    const setInitialFieldValue = useCallback((name: string, value: any) => {
        waitingForFormReset.current = true
        setInitialValues((state: any) => {
            const nextState = _.cloneDeep(state)
            _.set(nextState, name, value)
            console.log(`setInitialFieldValue: ${name} = ${value}`, nextState);
            return nextState
        })
    }, [setInitialValues])

    useEffect(() => { waitingForFormReset.current = false }, [initialValues])

    const [setFieldValueFromLookup, setInitialFieldValueFromLookup] = useSetFieldValueFromLookup(setInitialFieldValue)

    const pageType = useSelector((state: RootState) => pageName ? state.pagesSlice[pageName].type : _pageType)


    const selectedItem = useSelector((state: RootState) => pageName ? state.pagesSlice[pageName].selectedItem : _processPrinterSetupParamInterface)

    const touchedRef = useRef<any>({})
    useEffect(() => {
        touchedRef.current = { ...touched }
    }, [touched])

    const wasChangedRef = useRef<any>({})
    useEffect(() => {
        // reset on initialValues change
        wasChangedRef.current = {}
    }, [formMode, initialValues])
    useEffect(() => {
        for (const key of Object.keys(values)) {
            if (!wasChangedRef.current[key] && !_.isEqual(initialValues[key], values[key])) {
                wasChangedRef.current[key] = true
            }
        }
    }, [initialValues, values])

    // handle valuesToSet
    const appliedValuesToSet = useRef<any>(null)
    const appliedOnInitialValues = useRef<any>(null)
    const { loadUserParamsProcessPrinterSetupParamInterfaceStatus } = useSelector(selectDefaultvalues)
    useEffect(() => {
        if (loadUserParamsProcessPrinterSetupParamInterfaceStatus === 'pending') { return }
        // skip if nothing to set or already applied
        if (waitingForFormReset.current || !valuesToSet || !Object.keys(valuesToSet).length || (valuesToSet === appliedValuesToSet.current && initialValues === appliedOnInitialValues.current)) { return }

        appliedValuesToSet.current = valuesToSet
        appliedOnInitialValues.current = initialValues
        setValues((currentValues: any) => {
            let newValues = { ...currentValues, ...appliedValuesToSet.current }
            console.log('IxProcessPrinterSetupParamInterfaceFormContent: setting values from valuesToSet', appliedValuesToSet, 'currentValues', currentValues, 'newValues', newValues)
            return newValues
        })
    }, [valuesToSet, initialValues, setValues, loadUserParamsProcessPrinterSetupParamInterfaceStatus])
    
    // this calls the validation with some minimal delay so we can change
    // multiple fields ahd still have single validation ran with the latest
    // values only
    // !! changes with `setFieldValue` should not trigger validation so we
    // don't have multiple validation runs on the same values
    useEffect(() => {
        const timerId = setTimeout(() => {
            validateForm()
        }, 200)

        return () => clearTimeout(timerId)
    }, [values, validateForm])


    // update notifications bubble on error or language change
    // touched and errors are cast to any because they raise some funny error
    // about using string as key
    useEffect(() => {
        if (touched && errors && pageName) {
            const touchedFields = Object.keys(errors).filter(k => (touched as any)[k])
            const messages = touchedFields.map((k: string) => {
                if (labelsMap[k]) {
                    return `${t(labelsMap[k])}: ${t((errors as any)[k].key, (errors as any)[k].options)}`
                } else {
                    return `${k}: ${t((errors as any)[k].key, (errors as any)[k].options)}`
                }
            })
            let notifications = messages.map((err: string, i: number) => ({ type: 'error', msg: err, name: touchedFields[i] }))
            if ((errors as any).globalErrors) {
                const { error, warning, info } = (errors as any).globalErrors
                error && (notifications = notifications.concat(error.map(prepareNotification('error', labelsMap, t))))
                warning && (notifications = notifications.concat(warning.map(prepareNotification('warning', labelsMap, t))))
                info && (notifications = notifications.concat(info.map(prepareNotification('info', labelsMap, t))))
            }
            dispatch(setNotificationsByKeyThunk(notifications, 'processPrinterSetupParamInterface-form'))
        }
    }, [errors, touched, dispatch, i18n.language, t, pageName])


    useEffect(() => {
        // when component is destoyed remove any notifications set in the above useEffect
        return () => dispatch(removeNotificationsByKeyThunk('processPrinterSetupParamInterface-form'))
    }, [dispatch])

    useEffect(() => {
        if (pageName) {
            dispatch(setDirty({ name: pageName, formName: 'IxProcessPrinterSetupParamInterfaceForm', dirty }))
        }
    }, [dirty, dispatch, pageName])

    useEffect(() => {
        if (active && ((formMode === FormMode.Reset && pageName) || (formMode === FormMode.Create && !pageName))) {
            resetForm()
            resetMode && resetMode()
        }
    }, [formMode, resetForm, active, resetMode, pageName])

    useEffect(() => {
        if (formMode === FormMode.Edit && values.HDR_ID !== selectedItem?.HDR_ID) { return }
        pageType === 'page' && pageName && dispatch(selectionBannerChanged({ name: pageName, banner: values }))
    }, [values, dispatch, pageName, pageType, formMode, selectedItem?.HDR_ID])

    const prevLookupData = useRef<any>(null)
    useEffect(() => {
        if (pageType !== 'page') { return }

        // formik values are not set yet so we don't want to delete selection banner data
        if (formMode === FormMode.Edit && values.HDR_ID !== selectedItem?.HDR_ID) { return }

        const lookupData = lookupFields.reduce((acc: any, fieldName: string) => {
            const v = getFieldValue(fieldName, false)
            const vFull = getFieldValue(fieldName)
            if ((values[fieldName] && values[fieldName] === v && typeof(vFull) === 'object') || (!values[fieldName] && !v)) {
                acc[fieldName] = vFull
            }
            return acc
        }, ({} as any))

        if (!_.isEqual(prevLookupData.current, lookupData)) {
            prevLookupData.current = lookupData
            if (pageName) {
                dispatch(selectionBannerLookupDataChanged({ name: pageName, bannerLookupData: lookupData }))
            }
        }
    }, [dispatch, pageName, pageType, getFieldValue, values, formMode, selectedItem?.HDR_ID])

    const firstRender = useRef(true)
    const initialValuesSet = useRef<any>({})
    useEffect(() => { firstRender.current = true; initialValuesSet.current = {} }, [initialValues, formMode])  // reset firstRender ref on every initial values change



    useEffect(() => { firstRender.current = false })  // reset firstrRender ref afther thunks are called

    useEffect(() => {
        const _nextPrevValues = { ..._prevValues.current }
        lookupFields.forEach(f => {
            if (_nextPrevValues[f] !== values[f] && values[f] === getFieldValue(f, false)) {
                _nextPrevValues[f] = values[f]
            }
        })
        _prevValues.current = _nextPrevValues
    }, [values, getFieldValue])

    return null
}

type IIxProcessPrinterSetupParamInterfaceFormContentProps = {
    availableResultActions?: any[],
    hasPrinterBtns?: boolean,
    loadingEnabled: boolean,
    active: boolean,
    pageName: string,
    formMode: FormMode,
    setError?: Function,
    formType?: 'normal' | 'field' | 'gridForm',
    onReset?: Function,
    showSubForm: Function,
    hideSubForm: Function,
    addCrumb?: Function,
    popCrumb?: Function,
    setActions?: Function,
    portalId?: string,
    moduleRight: IxModuleRights,
    valuesToSet?: any,
}

export const IxProcessPrinterSetupParamInterfaceFormContent = (
    {
        availableResultActions=[],
        hasPrinterBtns,
        active,
        loadingEnabled,
        pageName,
        formMode,
        setError,
        formType='normal',
        onReset,
        showSubForm,
        hideSubForm,
        addCrumb,
        popCrumb,
        portalId,
        moduleRight = IxModuleRights.All,
        setActions: _setActions,
        ...props
    }: IIxProcessPrinterSetupParamInterfaceFormContentProps
) => {
    const { t } = useTranslation()
    const dispatch = useAppDispatch()

    const formRef = useRef(null)

    const {
        values,  // eslint-disable-line @typescript-eslint/no-unused-vars
        setValues,
        errors,
        touched,
        isSubmitting,
        handleReset,
        dirty,
        handleSubmit,
        initialValues,
        
    } = useFormikContext<any>()

    const { getFieldValue } = useIxLookupContext()  // eslint-disable-line @typescript-eslint/no-unused-vars

    const {value: formFieldType} = useSelector((state: RootState) => settingsMenuSelector(state, Settings.formFieldType))

    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const processPrinterSetupParamInterface = useSelector((state: RootState) => pageName ? state.pagesSlice[pageName].selectedItem : _processPrinterSetupParamInterface)


    const [ fieldsVis, visDispatch ] = useReducer(visReducer, visInitialState)
    const [orderMap, setOrderMap] = useState<any>(Object.keys(fieldsVis).map(Number))
    const {value: expandedFormGroups, id: expandedFormGroupsId} = useSelector((state: RootState) => settingsMenuSelector(state, 'processPrinterSetupParamInterface-form'))
    const [firstRender, setFirstRender] = useState(true)
    const setOrderFormGroupsData = useUserSettingsUpdate()

    const onFieldContentReady = useCallback((groupId: number, fieldName: string) => {
        visDispatch({ type: 'show', groupId, fieldName })
    }, [])
    const onEmptyFieldContentReady = useCallback((groupId: number, fieldName: string) => {
        visDispatch({ type: 'hide', groupId, fieldName })
    }, [])

    const itemsData = useMemo(() => ([
        { name: 'Type', index: 1, type: 'field' },
        { name: 'UserId', index: 1, type: 'field' },
        { name: 'ReportId', index: 1, type: 'field' },
        { name: 'DoDelete', index: 0, type: 'field' },
        { name: 'ResultAction', index: 1, type: 'field' },
        { name: 'PrnSrvcRelId', index: 1, type: 'field' },
        { name: 'StdBinPrSettId', index: 1, type: 'field' },
        { name: 'Bin1PrSettId', index: 1, type: 'field' },
        { name: 'Bin2PrSettId', index: 1, type: 'field' },
        { name: 'DuplexPrSettId', index: 1, type: 'field' },
        { name: 'PrnSrvcPathId', index: 1, type: 'field' },
        { name: 'RelativePath', index: 0, type: 'field' },

        { name: formMode === FormMode.Edit ? t('global:button.save') : t('global:button.create'), index: 0, type: 'button' },
        { name: t('global:button.cancel'), index: 0, type: 'button' },
    ]), [t, formMode])

    const _firstRender = useRef(true)

    useEffect(() => {
        const timeoutId = setTimeout(() => {
            // focus first editable field
            if (!_firstRender.current) { return }
            _firstRender.current = false

            for(let item in itemsData) {
                const fieldElement = (formRef.current as any)?.querySelectorAll(`[name="${itemsData[item].name}"]`)[itemsData[item].index]

                if (fieldElement && fieldElement.getAttribute('aria-readonly') !== 'true' && fieldElement.getAttribute('aria-disabled') !== 'true') {
                    if (fieldElement.type === 'hidden') {
                        if (fieldElement.parentElement.role === 'checkbox') {fieldElement.parentElement.focus()}
                        else {
                            const radiobtn = fieldElement.parentElement.querySelectorAll('.dx-item.dx-radiobutton')[0]

                            fieldElement.parentElement.querySelectorAll('.dx-item.dx-radiobutton')[0].closest('.dx-field-input.dx-radiogroup').focus()
                            fieldElement.parentElement.querySelector('.dx-item.dx-radiobutton.dx-item-selected').classList.remove('dx-state-focused')
                            radiobtn.classList.add('dx-state-focused')
                            radiobtn.focus()
                        }
                    }
                    else {fieldElement.focus()}

                    break
                }
            }
        }, 100)

        return () => clearTimeout(timeoutId)
    }, [itemsData])

    const lastFocusedElement = useRef<any>(null)
    const onKeyboardControl = useMemo(() => keyboardControl(itemsData, t, formRef, lastFocusedElement), [itemsData, t])

    useEffect(() => {
        if (active) {
            let formElement: HTMLElement = (formRef.current as any).closest('.dx-drawer-content')
            if (!formElement) {  // if the form is in a popup we should attach the keyboard control to the popup
                formElement = (formRef.current as any).closest('.dx-popup-content')
            }

            formElement?.addEventListener('keydown', onKeyboardControl, true)

            return () => {
                formElement?.removeEventListener('keydown', onKeyboardControl, true)
            }
        }
    },[active, onKeyboardControl])

    useEffect(() => {
        if (active) {
            const formElement: any = formRef.current

            if (formFieldType === 'label-inside-max-field-width' || formFieldType === 'label-left-max-field-width') {
                setTimeout(() => {
                    setMaxLabelWidth(formElement)
                }, 500)
            }
            else {
                formElement?.style.removeProperty('--max-labels-width')
            }
        }

    },[active, formFieldType])

    useEffect(() => {
        if (active) {
            const formElement: any = document.getElementById('processPrinterSetupParamInterface-form')

            const setPrevFocusedElement = (e: any) => {
                if (e.target.tagName === 'INPUT' || e.target.tagName === 'I' || e.target.className.includes('dropdowneditor')) {
                    lastFocusedElement.current = e.target
                    formElement?.querySelector('.dx-state-focused.dx-radiobutton')?.classList.remove('dx-state-focused')
                    formElement?.querySelector('.dx-checkbox.dx-state-focused')?.classList.remove('dx-state-focused')
                }
            }
            formElement?.addEventListener('mousedown', setPrevFocusedElement)

            return () => {
                formElement?.removeEventListener('mousedown', setPrevFocusedElement)
            }
        }
        }, [active])

    const resetMode = useCallback(() => {
        if (pageName) {
            dispatch(setFormModes({ name: pageName, modes: { IxProcessPrinterSetupParamInterfaceForm: FormMode.Create } }))
        }
    }, [dispatch, pageName])

    const _onReset = useCallback(() => {
        const _handleReset = () => {
            handleReset()
            onReset && onReset()
        }

        if (dirty) {
            dispatch(showCPopup({
                confirmCb: _handleReset,
                title: t('global:label.discardChanges'),
                description: t('global:question.discardChanges'),
            }))
        } else {
            _handleReset()
        }
    }, [dispatch, handleReset, t, onReset, dirty])



    
    const createBtnRef = useRef(null)
    const createBtnOnScreen = useIxOnScreen(createBtnRef)
    const formOnScreen = useIxOnScreen(formRef)

    const activeLicenses = useSelector((state: RootState) => state.rights.activeLicenses)

    const buttonsConfig = useMemo(() => {
        const btns: any[] = [
            {
                hint: formType === 'field' ? 'Ok' : t(`global:button.${ formMode === FormMode.Create ? 'create': 'update' }`),
                icon: formType === 'field' ? BaseIcons.Create : ( formMode === FormMode.Create ? BaseIcons.Create : BaseIcons.Update ),
                disabled: moduleRight === IxModuleRights.Info,
                onClick: () => handleSubmit(),
            },
            {
                hint: t('global:button.cancel'),
                icon: BaseIcons.Cancel,
                disabled: !dirty && formType === 'normal',
                onClick: () => _onReset()
            }
        ]

        return btns
    }, [handleSubmit, _onReset, formType, formMode, t, dirty, moduleRight])


    useEffect(() => {
        if (active && loadingEnabled) {
            const actions = [
                { id: 1, name: '', widget: 'delimiter', location: 'before' },
                ...buttonsConfig.map((b: any, i: number) => ({
                    id: i + 2,
                    name: b.hint,
                    widget: b.disabled ? 'disabledbtn' : 'button',
                    options: { icon: b.icon, onClick: b.onClick, disabled: b.disabled },
                    location: 'before',
                })),
                { id: buttonsConfig.length + 2, name: '', widget: 'delimiter', location: 'before' },
            ]

            if (formType === 'normal') {
                _setActions && _setActions(actions)
            }
        }
    }, [dispatch, activeLicenses, formType, buttonsConfig, loadingEnabled, active, _setActions, moduleRight, formMode])

    const resultactionOpts = useMemo(() => availableResultActions?.map((item: any) => ixkeinePrinterSetupExeResultActionToOpts(t, {  }).find((action: any) => action.value === item)), [availableResultActions, t])


    useEffect(() => {
        if (firstRender) {
            setFirstRender(false)

            if (expandedFormGroups && Object.hasOwn(expandedFormGroups, 'orderMap')) {
                setOrderMap(expandedFormGroups.orderMap)
            }
        }

    },[expandedFormGroups, firstRender, dispatch])

    const onMoveDown = useCallback((id: number) => {
        const arr = [...orderMap]
        const index: any = arr.indexOf(id)
        if (index || index === 0) {
            [arr[index], arr[index + 1]] = [arr[index + 1], arr[index]]
            setOrderMap(arr)
            setOrderFormGroupsData('form-layout', 'processPrinterSetupParamInterface-form', {...expandedFormGroups, orderMap: arr}, expandedFormGroupsId, SettingType.GlobalSetting)
        }

    },[orderMap, expandedFormGroups, setOrderFormGroupsData, expandedFormGroupsId])

    const onMoveUp = useCallback((id: number) => {
        const arr = [...orderMap]
        const index: any = arr.indexOf(id)

        if (index) {
            [arr[index - 1], arr[index]] = [arr[index], arr[index - 1]]
            setOrderMap(arr)
            setOrderFormGroupsData('form-layout', 'processPrinterSetupParamInterface-form', {...expandedFormGroups, orderMap: arr}, expandedFormGroupsId, SettingType.GlobalSetting)
        }

    },[orderMap, expandedFormGroups, setOrderFormGroupsData, expandedFormGroupsId])

    if (formMode === FormMode.Reset) {
        return <Spinner />
    }

    return active ? (
        <div ref={formRef}>
            <FocusHandler itemsData={ itemsData } lastFocusedElement={ lastFocusedElement }/>
            <Form id='processPrinterSetupParamInterface-form'>
                <div style={ { display: 'flex', flexDirection: 'column' } }>
                    <FormGroup formId='processPrinterSetupParamInterface-form' onMoveDown={ onMoveDown } onMoveUp={ onMoveUp } orderMap={ orderMap } id={ 0 } name={ t('processprintersetupparaminterface:formGroup.') } caption={ true } style={ isGroupVisible(fieldsVis, 0) ? {} : { display: 'none' } }>
                        <ResponsiveBox>
                            <Row />
                            <Row screen='xs sm'/>
                            <Row screen='xs'/>
                            <Row screen='xs'/>

                            <Col />
                            <Col screen='sm md lg'/>
                            <Col screen='md lg'/>
                            <Col screen='md lg'/>

                            <Item>
                                    <Location row={ 0 } col={ 0 } colspan={ 1 } screen='md lg' />
                                    <Location row={ 0 } col={ 0 } colspan={ 1 } screen='sm' />
                                    <Location row={ 0 } col={ 0 } colspan={ 1 } screen='xs' />

                                    <div className='item-div'>
                                        { false
                                            ? (
                                                <IxField
                                                    as={ NumberInput }
                                                    name='Type'
                                                    label={ t(labelsMap['Type']) }
                                                    active={ loadingEnabled }
                                                    groupId={ 0 }
                                                    onContentReady={ onFieldContentReady }
                                                    readOnly={ hasPrinterBtns || Array.from('I').includes(moduleRight) }
                                                />
                                            )
                                            : (
                                                <IxEmptyField name='Type' groupId={ 0 } onContentReady={ onEmptyFieldContentReady }/>
                                            )
                                        }
                                    </div>
                                </Item>
                            <Item>
                                    <Location row={ 0 } col={ 1 } colspan={ 1 } screen='md lg' />
                                    <Location row={ 0 } col={ 1 } colspan={ 1 } screen='sm' />
                                    <Location row={ 1 } col={ 0 } colspan={ 1 } screen='xs' />

                                    <div className='item-div'>
                                        { false
                                            ? (
                                                <IxField
                                                    as={ NumberInput }
                                                    name='UserId'
                                                    label={ t(labelsMap['UserId']) }
                                                    active={ loadingEnabled }
                                                    groupId={ 0 }
                                                    onContentReady={ onFieldContentReady }
                                                    readOnly={ hasPrinterBtns || Array.from('I').includes(moduleRight) }
                                                />
                                            )
                                            : (
                                                <IxEmptyField name='UserId' groupId={ 0 } onContentReady={ onEmptyFieldContentReady }/>
                                            )
                                        }
                                    </div>
                                </Item>
                            <Item>
                                    <Location row={ 0 } col={ 2 } colspan={ 1 } screen='md lg' />
                                    <Location row={ 1 } col={ 0 } colspan={ 1 } screen='sm' />
                                    <Location row={ 2 } col={ 0 } colspan={ 1 } screen='xs' />

                                    <div className='item-div'>
                                        { false
                                            ? (
                                                <IxField
                                                    as={ NumberInput }
                                                    name='ReportId'
                                                    label={ t(labelsMap['ReportId']) }
                                                    active={ loadingEnabled }
                                                    groupId={ 0 }
                                                    onContentReady={ onFieldContentReady }
                                                    readOnly={ hasPrinterBtns || Array.from('I').includes(moduleRight) }
                                                />
                                            )
                                            : (
                                                <IxEmptyField name='ReportId' groupId={ 0 } onContentReady={ onEmptyFieldContentReady }/>
                                            )
                                        }
                                    </div>
                                </Item>
                            <Item>
                                    <Location row={ 0 } col={ 3 } colspan={ 1 } screen='md lg' />
                                    <Location row={ 1 } col={ 1 } colspan={ 1 } screen='sm' />
                                    <Location row={ 3 } col={ 0 } colspan={ 1 } screen='xs' />

                                    <div className='item-div'>
                                        { false
                                            ? (
                                                <IxField
                                                    as={ CheckBoxInput }
                                                    name='DoDelete'
                                                    label={ t(labelsMap['DoDelete']) }
                                                    active={ loadingEnabled }
                                                    groupId={ 0 }
                                                    onContentReady={ onFieldContentReady }
                                                    readOnly={ hasPrinterBtns || Array.from('I').includes(moduleRight) }
                                                />
                                            )
                                            : (
                                                <IxEmptyField name='DoDelete' groupId={ 0 } onContentReady={ onEmptyFieldContentReady }/>
                                            )
                                        }
                                    </div>
                                </Item>
                        </ResponsiveBox>
                    </FormGroup>
                    <FormGroup formId='processPrinterSetupParamInterface-form' onMoveDown={ onMoveDown } onMoveUp={ onMoveUp } orderMap={ orderMap } id={ 1 } name={ t('processprintersetupparaminterface:formGroup.Einstellungen') } caption={ true } style={ isGroupVisible(fieldsVis, 1) ? {} : { display: 'none' } }>
                        <ResponsiveBox>
                            <Row />

                            <Col />
                            <Col screen='sm md lg'/>
                            <Col screen='md lg'/>
                            <Col screen='md lg'/>

                            <Item>
                                    <Location row={ 0 } col={ 0 } colspan={ 4 } screen='md lg' />
                                    <Location row={ 0 } col={ 0 } colspan={ 1 } screen='sm' />
                                    <Location row={ 0 } col={ 0 } colspan={ 1 } screen='xs' />

                                    <div className='item-div'>
                                        <IxField
                                            as={ SelectInput }
                                            name='ResultAction'
                                            label={ t(labelsMap['ResultAction']) }
                                            active={ loadingEnabled }
                                            opts={ resultactionOpts }
                                            groupId={ 1 }
                                            onContentReady={ onFieldContentReady }
                                            readOnly={ hasPrinterBtns || Array.from('I').includes(moduleRight) }
                                        />
                                    </div>
                                </Item>
                        </ResponsiveBox>
                    </FormGroup>
                    <FormGroup formId='processPrinterSetupParamInterface-form' onMoveDown={ onMoveDown } onMoveUp={ onMoveUp } orderMap={ orderMap } id={ 2 } name={ t('processprintersetupparaminterface:formGroup.Druckereinstellungen') } caption={ true } style={ isGroupVisible(fieldsVis, 2) ? {} : { display: 'none' } }>
                        <ResponsiveBox>
                            <Row />
                            <Row />
                            <Row />
                            <Row />
                            <Row />

                            <Col />
                            <Col screen='sm md lg'/>
                            <Col screen='md lg'/>
                            <Col screen='md lg'/>

                            <Item>
                                    <Location row={ 0 } col={ 0 } colspan={ 4 } screen='md lg' />
                                    <Location row={ 0 } col={ 0 } colspan={ 1 } screen='sm' />
                                    <Location row={ 0 } col={ 0 } colspan={ 1 } screen='xs' />

                                    <div className='item-div'>
                                        { (values.ResultAction === 1 || values.ResultAction === 3)
                                            ? (
                                                <IxField
                                                    as={ IxPrnSrvcPrinterLookup }
                                                    name='PrnSrvcRelId'
                                                    label={ t(labelsMap['PrnSrvcRelId']) }
                                                    active={ loadingEnabled }
                                                    groupId={ 2 }
                                                    onContentReady={ onFieldContentReady }
                                                    readOnly={ hasPrinterBtns || Array.from('I').includes(moduleRight) }
                                                />
                                            )
                                            : (
                                                <IxEmptyField name='PrnSrvcRelId' groupId={ 2 } onContentReady={ onEmptyFieldContentReady }/>
                                            )
                                        }
                                    </div>
                                </Item>
                            <Item>
                                    <Location row={ 1 } col={ 0 } colspan={ 4 } screen='md lg' />
                                    <Location row={ 0 } col={ 1 } colspan={ 1 } screen='sm' />
                                    <Location row={ 1 } col={ 0 } colspan={ 1 } screen='xs' />

                                    <div className='item-div'>
                                        { (values.ResultAction === 1 || values.ResultAction === 3)
                                            ? (
                                                <IxField
                                                    as={ NumberInput }
                                                    name='StdBinPrSettId'
                                                    label={ t(labelsMap['StdBinPrSettId']) }
                                                    active={ loadingEnabled }
                                                    groupId={ 2 }
                                                    onContentReady={ onFieldContentReady }
                                                    readOnly={ hasPrinterBtns || Array.from('I').includes(moduleRight) }
                                                />
                                            )
                                            : (
                                                <IxEmptyField name='StdBinPrSettId' groupId={ 2 } onContentReady={ onEmptyFieldContentReady }/>
                                            )
                                        }
                                    </div>
                                </Item>
                            <Item>
                                    <Location row={ 2 } col={ 0 } colspan={ 4 } screen='md lg' />
                                    <Location row={ 1 } col={ 0 } colspan={ 1 } screen='sm' />
                                    <Location row={ 2 } col={ 0 } colspan={ 1 } screen='xs' />

                                    <div className='item-div'>
                                        { (values.ResultAction === 1 || values.ResultAction === 3) && (values.Type === 0)
                                            ? (
                                                <IxField
                                                    as={ NumberInput }
                                                    name='Bin1PrSettId'
                                                    label={ t(labelsMap['Bin1PrSettId']) }
                                                    active={ loadingEnabled }
                                                    groupId={ 2 }
                                                    onContentReady={ onFieldContentReady }
                                                    readOnly={ hasPrinterBtns || Array.from('I').includes(moduleRight) }
                                                />
                                            )
                                            : (
                                                <IxEmptyField name='Bin1PrSettId' groupId={ 2 } onContentReady={ onEmptyFieldContentReady }/>
                                            )
                                        }
                                    </div>
                                </Item>
                            <Item>
                                    <Location row={ 3 } col={ 0 } colspan={ 4 } screen='md lg' />
                                    <Location row={ 1 } col={ 1 } colspan={ 1 } screen='sm' />
                                    <Location row={ 3 } col={ 0 } colspan={ 1 } screen='xs' />

                                    <div className='item-div'>
                                        { (values.ResultAction === 1 || values.ResultAction === 3) && (values.Type === 0)
                                            ? (
                                                <IxField
                                                    as={ NumberInput }
                                                    name='Bin2PrSettId'
                                                    label={ t(labelsMap['Bin2PrSettId']) }
                                                    active={ loadingEnabled }
                                                    groupId={ 2 }
                                                    onContentReady={ onFieldContentReady }
                                                    readOnly={ hasPrinterBtns || Array.from('I').includes(moduleRight) }
                                                />
                                            )
                                            : (
                                                <IxEmptyField name='Bin2PrSettId' groupId={ 2 } onContentReady={ onEmptyFieldContentReady }/>
                                            )
                                        }
                                    </div>
                                </Item>
                            <Item>
                                    <Location row={ 4 } col={ 0 } colspan={ 4 } screen='md lg' />
                                    <Location row={ 2 } col={ 0 } colspan={ 1 } screen='sm' />
                                    <Location row={ 4 } col={ 0 } colspan={ 1 } screen='xs' />

                                    <div className='item-div'>
                                        { (values.ResultAction === 1 || values.ResultAction === 3)
                                            ? (
                                                <IxField
                                                    as={ NumberInput }
                                                    name='DuplexPrSettId'
                                                    label={ t(labelsMap['DuplexPrSettId']) }
                                                    active={ loadingEnabled }
                                                    groupId={ 2 }
                                                    onContentReady={ onFieldContentReady }
                                                    readOnly={ hasPrinterBtns || Array.from('I').includes(moduleRight) }
                                                />
                                            )
                                            : (
                                                <IxEmptyField name='DuplexPrSettId' groupId={ 2 } onContentReady={ onEmptyFieldContentReady }/>
                                            )
                                        }
                                    </div>
                                </Item>
                        </ResponsiveBox>
                    </FormGroup>
                    <FormGroup formId='processPrinterSetupParamInterface-form' onMoveDown={ onMoveDown } onMoveUp={ onMoveUp } orderMap={ orderMap } id={ 3 } name={ t('processprintersetupparaminterface:formGroup.Speichereinstellungen') } caption={ true } style={ isGroupVisible(fieldsVis, 3) ? {} : { display: 'none' } }>
                        <ResponsiveBox>
                            <Row />
                            <Row />

                            <Col />
                            <Col screen='sm md lg'/>
                            <Col screen='md lg'/>
                            <Col screen='md lg'/>

                            <Item>
                                    <Location row={ 0 } col={ 0 } colspan={ 4 } screen='md lg' />
                                    <Location row={ 0 } col={ 0 } colspan={ 1 } screen='sm' />
                                    <Location row={ 0 } col={ 0 } colspan={ 1 } screen='xs' />

                                    <div className='item-div'>
                                        { (values.ResultAction === 2 || values.ResultAction === 3)
                                            ? (
                                                <IxField
                                                    as={ NumberInput }
                                                    name='PrnSrvcPathId'
                                                    label={ t(labelsMap['PrnSrvcPathId']) }
                                                    active={ loadingEnabled }
                                                    groupId={ 3 }
                                                    onContentReady={ onFieldContentReady }
                                                    readOnly={ hasPrinterBtns || Array.from('I').includes(moduleRight) }
                                                />
                                            )
                                            : (
                                                <IxEmptyField name='PrnSrvcPathId' groupId={ 3 } onContentReady={ onEmptyFieldContentReady }/>
                                            )
                                        }
                                    </div>
                                </Item>
                            <Item>
                                    <Location row={ 1 } col={ 0 } colspan={ 4 } screen='md lg' />
                                    <Location row={ 0 } col={ 1 } colspan={ 1 } screen='sm' />
                                    <Location row={ 1 } col={ 0 } colspan={ 1 } screen='xs' />

                                    <div className='item-div'>
                                        { (values.ResultAction === 2 || values.ResultAction === 3)
                                            ? (
                                                <IxField
                                                    as={ TextInput }
                                                    name='RelativePath'
                                                    label={ t(labelsMap['RelativePath']) }
                                                    active={ loadingEnabled }
                                                    groupId={ 3 }
                                                    onContentReady={ onFieldContentReady }
                                                    readOnly={ hasPrinterBtns || Array.from('I').includes(moduleRight) }
                                                />
                                            )
                                            : (
                                                <IxEmptyField name='RelativePath' groupId={ 3 } onContentReady={ onEmptyFieldContentReady }/>
                                            )
                                        }
                                    </div>
                                </Item>
                        </ResponsiveBox>
                    </FormGroup>

                    
                    <div style={ {order: orderMap.length, display: 'none' } }>
                        <div ref={ createBtnRef } style={{marginTop: '1rem', marginLeft: '0.5rem'}}>
                            { buttonsConfig.map((b: any, i: number) => (
                                <Button
                                    key={ i }
                                    text={ b.hint }
                                    type='default'
                                    style={ { marginRight: i !== buttonsConfig.length -1 ? '0.5rem' : undefined } }
                                    { ...b }
                                />
                            )) }
                        </div>
                        <div className='' style={{marginTop: '1rem', marginLeft: '0.5rem'}}>
                        </div>
                    </div>

                    <div className='rb-container' style={ {order: orderMap.length + 2} }>
                        <div className='rb-item' style={{marginLeft: '0.5rem'}}>
                            <ValidationSummary
                                touched={ touched }
                                errors={ errors }
                                labelsMap={ labelsMap }
                            />
                        </div>
                    </div>
                </div>
            </Form>

            <LoadPanel
                position={ { of: '#content' } }
                visible={isSubmitting}
                shadingColor='rgba(0, 0, 0, 0.4)'
                shading={true}
                showIndicator={true}
                showPane={true}
            />

        </div>
    ) : null
}


type FormContentWrapperProps = {
    id: number,
    pageActive?: boolean,
    pageLoadingEnabled?: boolean,
    pageName: string,
    setInitialValues: (values: any) => void
    setError?: Function,
    showSubForm: Function,
    hideSubForm: Function,
    addCrumb?: Function,
    popCrumb?: Function,
    setActions?: Function,
    moduleRight: IxModuleRights,
    valuesToSet?: any,
}

const FormContentWrapper = ({
        id,
        pageActive,
        pageLoadingEnabled,
        pageName,
        setInitialValues,
        setError,
        showSubForm,
        hideSubForm,
        addCrumb,
        popCrumb,
        setActions,
        moduleRight = IxModuleRights.All,
        valuesToSet = null
}: FormContentWrapperProps) => {
    const dispatch = useAppDispatch()
    const pageActiveTabIndex = useSelector((state: RootState) => pageName ? state.pagesSlice[pageName].activeTabIndex : 0)
    const active: boolean = useMemo(() => (pageActive || pageActive === undefined) && pageActiveTabIndex === id, [pageActive, pageActiveTabIndex, id])
    const loadingEnabled: boolean = useMemo(() => (pageLoadingEnabled || pageLoadingEnabled === undefined) && pageActiveTabIndex === id, [pageLoadingEnabled, pageActiveTabIndex, id])
    const formMode = useSelector((state: RootState) => pageName ? (state.pagesSlice[pageName].formMode['IxProcessPrinterSetupParamInterfaceForm'] || FormMode.Create) : _formMode)

    const resetMode = useCallback(() => {
        if (pageName) {
            dispatch(setFormModes({ name: pageName, modes: { IxProcessPrinterSetupParamInterfaceForm: FormMode.Create } }))
        }
    }, [dispatch, pageName])

    return (
        <div>
            <AutoUpdateForm
                pageName={ pageName }
                formMode={ formMode }
                active={ active }
                resetMode={ resetMode }
                setInitialValues={ setInitialValues }
                valuesToSet={ valuesToSet }
            />
            <IxProcessPrinterSetupParamInterfaceFormContent
                active={ active && formMode !== FormMode.Reset }
                loadingEnabled={ loadingEnabled }
                pageName={ pageName }
                formMode={ formMode }


                setError={ setError }

                showSubForm={ showSubForm }
                hideSubForm={ hideSubForm }
                portalId='processPrinterSetupParamInterface-portal'

                addCrumb={ addCrumb }
                popCrumb={ popCrumb }

                setActions={ setActions }

                moduleRight={ moduleRight }
            />
        </div>
    )
}

const selectDefaultvalues = createSelector(
    [
        (state: RootState) => state.processPrinterSetupParamInterfaceSlice.defaultValues,
        (state: RootState) => state.processPrinterSetupParamInterfaceSlice.loadUserParamsProcessPrinterSetupParamInterfaceStatus,
    ],
    (defaultValues, loadUserParamsProcessPrinterSetupParamInterfaceStatus) => ({
        defaultValues,
        loadUserParamsProcessPrinterSetupParamInterfaceStatus,
    })
)


type IxProcessPrinterSetupParamInterfaceFormProps = {
    id: number,
    parentPageName?: string,
    pageName: string,
    pageActive?: boolean,
    pageLoadingEnabled?: boolean,
    setActions: (id: number, actions: any[]) => void,
    setError?: Function,
    onSubmitted?: Function,
    addCrumb?: Function,
    popCrumb?: Function,
    moduleName?: string,
    isNested?: boolean,
    preloadedData?: any,
}

export const IxProcessPrinterSetupParamInterfaceForm = ({
    id,
    parentPageName,
    pageName,
    pageActive,
    pageLoadingEnabled,
    setActions,
    setError,
    onSubmitted,
    addCrumb,
    popCrumb,
    moduleName = '',
    isNested,
    preloadedData,
}: IxProcessPrinterSetupParamInterfaceFormProps) => {
    const dispatch = useAppDispatch()
    const { t } = useTranslation()  // eslint-disable-line
    const { defaultValues, loadUserParamsProcessPrinterSetupParamInterfaceStatus } = useSelector(selectDefaultvalues)

    const pageActiveTabIndex = useSelector((state: RootState) => pageName ? state.pagesSlice[pageName].activeTabIndex : 0)
    const active = useMemo(() => (pageActive || pageActive === undefined) && pageActiveTabIndex === id, [pageActive, pageActiveTabIndex, id])

    // load json schema from backend
    const schema = useIxJsonSchema('processPrinterSetupParamInterface')

    const processPrinterSetupParamInterface = useSelector((state: RootState) => pageName ? state.pagesSlice[pageName].selectedItem : _processPrinterSetupParamInterface)
    const formMode = useSelector((state: RootState) => pageName ? (state.pagesSlice[pageName].formMode['IxProcessPrinterSetupParamInterfaceForm'] || FormMode.Create) : _formMode)
    const { initialValues: additionalValues } = useSelector((state: RootState) => pageName ? state.pagesSlice[pageName].tabProps['IxProcessPrinterSetupParamInterfaceForm'] : _tabProps)
    const [dynamicInitialValues, setDynamicInitialValues] = useState({})

    const {
        startProcessPrinterSetupParamInterfaceError,
        loadUserParamsProcessPrinterSetupParamInterfaceError,
    } = useSelector((state: RootState) => state.processPrinterSetupParamInterfaceSlice)

    const { right: moduleRight } = useSelector((state: RootState) => rightsSelector(state, moduleName))


    const [fmvIndex, setFmvIndex] = useState(0)

    const showSubForm = useCallback(() => { setFmvIndex(1) }, [])
    const hideSubForm = useCallback(() => { setFmvIndex(0) }, [])

    const [_valuesToSet, _setValuesToSet] = useState<any>(null)
    const _preloadedData = useRef<any>(preloadedData)
    const appliedPreloadedData = useRef<any>(null)

    const submitting = useRef(false)

    useEffect(() => {
        if (!shallowEqual(_preloadedData.current, preloadedData)) {
            _preloadedData.current = preloadedData
        }
    }, [preloadedData])

    useEffect(() => {
        // handle error showing, either through setError or notification box
        let err: any = undefined
        let prefix: string = ''

        if (startProcessPrinterSetupParamInterfaceError) {
            err = startProcessPrinterSetupParamInterfaceError
            prefix = 'Create'
        } else if (loadUserParamsProcessPrinterSetupParamInterfaceError) {
            err = loadUserParamsProcessPrinterSetupParamInterfaceError
            prefix = 'Init'
        }

        if (err) {
            let notifications: any[] = []

            if (typeof(err) === 'object') {
                notifications = notifications.concat(err.error.map(prepareNotification('error', labelsMap, t)))
                notifications = notifications.concat(err.warning.map(prepareNotification('warning', labelsMap, t)))
                notifications = notifications.concat(err.info.map(prepareNotification('info', labelsMap, t)))

            } else {
                notifications = [{ msg: err, type: 'error' }]
            }

            if (setError) {
                setError({ prefix, err: notifications })
            } else {
                dispatch(setNotificationsByKeyThunk(notifications, 'processPrinterSetupParamInterface-form'))
                return () => dispatch(removeNotificationsByKeyThunk('processPrinterSetupParamInterface-form'))
            }
        } else {
            if (setError) {
                setError({ prefix: '', err: undefined })
            } else {
                dispatch(removeNotificationsByKeyThunk('processPrinterSetupParamInterface-form'))
            }
        }
    }, [
        setError,
        dispatch,
        t,
        startProcessPrinterSetupParamInterfaceError,
        loadUserParamsProcessPrinterSetupParamInterfaceError,
    ])

    const additionalValuesExt = useMemo(() => {
        let _additionalValuesExt: any = {}

        _additionalValuesExt = { ..._additionalValuesExt, ...additionalValues }

        return _additionalValuesExt
    }, [
        additionalValues,
    ])

    const [initialValues, setInitialValues] = useState(genInitialValues(additionalValuesExt))
    useEffect(() => {
        if (active) {
            dispatch(resetstartProcessPrinterSetupParamInterfaceError())
            dispatch(loadUserParamsProcessPrinterSetupParamInterface({  }))
        }
    }, [active, dispatch])

    const _setActions = useCallback((actionsIn: any[]) => {
        setActions && setActions(id, actionsIn)
    }, [setActions, id])

    const formik = useMemo(() => ({
        initialValues,
        enableReinitialize: true,
        jsonSchema: schema,
        additionalSchemas: {
            // todo: add schemas for additional tables somehow
        },
        avjOptions: {
            coerceTypes: true,
            $data: true,
        },
        onSubmit: async (_values: any, { setSubmitting, resetForm }: any) => {
            const { UiCalc, ...values } = _values
            dispatch(resetloadUserParamsProcessPrinterSetupParamInterfaceError())
            setSubmitting(true)
            submitting.current = true

            let processPrinterSetupParamInterface = { ...values }

            const saveRes = await dispatch(startProcessPrinterSetupParamInterface({ processPrinterSetupParamInterface }))
            setJobNotification((saveRes.payload as any).data.job_id, t, dispatch)
            if (saveRes.meta.requestStatus === 'fulfilled') {

                onSubmitted && onSubmitted()

            }
        }
    }), [
        initialValues,
        schema,
            t,
        dispatch,
        onSubmitted,
    ])

    useEffect(() => {
        if (submitting.current) { return }
        if (formMode === FormMode.Reset) {
            if (pageName) {
                dispatch(setSelection({ name: pageName, selection: 0 }))
            }
            setDynamicInitialValues(state => _.isEqual(state, {}) ? state : {})
            setInitialValues(genInitialValues(additionalValuesExt));
            return
        }

        if (_preloadedData.current !== undefined && !shallowEqual(_preloadedData.current, appliedPreloadedData.current)) {
            if (_preloadedData.current && _preloadedData.current.HDR_ID) {
                if (pageName) {
                    dispatch(setSelection({ name: pageName, selection: 1 }))
                    dispatch(setSelectedItem({ name: pageName, selectedItem: _preloadedData.current }))
                    dispatch(setFormModes({ name: pageName, modes: { IxProcessPrinterSetupParamInterfaceForm: FormMode.Edit } }))
                }
            }
            else {
                _setValuesToSet({ ..._preloadedData.current })
            }

            appliedPreloadedData.current = _preloadedData.current
            // do not return, default values should be set
        }

        if (formMode === FormMode.Edit) {
            const newInitialValues = { ...genInitialValues({ ...additionalValuesExt, ...dynamicInitialValues }), ...processPrinterSetupParamInterface }

            setInitialValues((initialValues: any) => {
                return !shallowEqual(initialValues, newInitialValues)
                    ? newInitialValues
                    : initialValues
            })
        } else {
            if (defaultValues) {
                let data = { ...defaultValues }
                datesToIso(data, dateFields)
                data = { ...genInitialValues({ ...additionalValuesExt, ...dynamicInitialValues }), ...data }
                setInitialValues((initialValues: any) => {
                    if (!shallowEqual(data, initialValues)) {
                        return data
                    } else {
                        return initialValues
                    }
                })
            }
        }
    }, [
        processPrinterSetupParamInterface,
        formMode,
        additionalValuesExt,
        preloadedData,
        dynamicInitialValues,
        pageName,
        dispatch,
        _setValuesToSet,
        defaultValues,
    ])


    useEffect(() => {
        if (active && addCrumb) {
            addCrumb('ProcessPrinterSetupParamInterfaceForm')
            return () => popCrumb && popCrumb()
        }
    }, [active, addCrumb, popCrumb])

    const lookupContextRef: any = useRef(null)
    useEffect(() => {
        // reset lookup context when changing the edited object
        lookupContextRef.current?.resetContext()
    }, [processPrinterSetupParamInterface])

    // this make sure some effects can be triggered before the form contents
    // are shown and lookups start loading data
    const [_active, _setActive] = useState(false)
    useEffect(() => { _setActive(active) }, [active])

    useEffect(() => {
        submitting.current = false
    }, [initialValues])

    const showSpinner = useMemo(() => {
        return !submitting.current && (
            !schema
            || loadUserParamsProcessPrinterSetupParamInterfaceStatus === 'pending'
        )
    }, [
        schema,
        loadUserParamsProcessPrinterSetupParamInterfaceStatus,
    ])

    // show loading indicator while json schema is fetched
    if (showSpinner) {
        return (<Spinner />)
    }

    return (
        <div style={ { contentVisibility: active ? 'visible' : 'hidden' } }>
            <MultiView
                selectedIndex={ fmvIndex }
                deferRendering={ false }
            >
                <MVItem>
                    <BaseForm {...formik}>
                        <IxLookupProvider ref={ lookupContextRef }>
                    {
                        _active ? (
                            <FormContentWrapper
                                id={ id }
                                pageActive={ pageActive }
                                pageLoadingEnabled={ pageLoadingEnabled }
                                pageName={ pageName }


                                setInitialValues={ setDynamicInitialValues }

                                setError={ setError }

                                showSubForm={ showSubForm }
                                hideSubForm={ hideSubForm }

                                addCrumb={ addCrumb }
                                popCrumb={ popCrumb }

                                setActions={ _setActions }

                                moduleRight={ moduleRight }
                                valuesToSet={ _valuesToSet }
                            />
                        ) : null
                    }
                        </IxLookupProvider>
                    </BaseForm>
                </MVItem>

                <MVItem>
                    <div id='processPrinterSetupParamInterface-portal'></div>
                </MVItem>
            </MultiView>
        </div>
    )
}

type IxFormFieldAutoUpdateProps = {
    active: boolean,
    onValueChanged: Function,
    onReset: Function,
}

const IxFormFieldAutoUpdate = React.forwardRef(({
    active,
    onValueChanged,
    // onReset,
}: IxFormFieldAutoUpdateProps, ref) => {
    const {
        values,  // eslint-disable-line @typescript-eslint/no-unused-vars
        dirty,
        setValues,
        // touched,
        // handleSubmit,
        // handleReset,
    } = useFormikContext<any>()

    // const dispatch = useAppDispatch()
    // const { t } = useTranslation()

    const skipValueChange = useRef(false)
    const prevValues = useRef(values)

    useImperativeHandle(ref, () => ({
        setValues: (_values: any) => {
            if (!_.isEqual(_values, values)) {
                skipValueChange.current = true
                setValues(_values, false)
            }
        }
    }), [values, setValues])

    useEffect(() => {
        if (active && !_.isEqual(values, prevValues.current) && dirty && onValueChanged) {
            if (!skipValueChange.current) {
                onValueChanged(values)
            }
            skipValueChange.current = false
        }
        prevValues.current = values
    }, [onValueChanged, values, active, dirty])

    return null
})

type IxProcessPrinterSetupParamInterfaceFormFieldProps = {
    availableResultActions?: any[],
    hasPrinterBtns?: boolean,
    active: boolean,
    loadingEnabled: boolean,
    label: string,
    setError?: Function,
    onSubmit: Function,
    onValueChanged: Function,
    onReset: Function,
    mode: FormMode,
    value: any,
    formType: 'field' | 'gridForm',
    addCrumb?: Function,
    popCrumb?: Function,
}

export const IxProcessPrinterSetupParamInterfaceFormField = React.forwardRef((
    {
        availableResultActions,
        hasPrinterBtns,
        active,
        loadingEnabled,
        label,
        setError,
        onSubmit,
        onValueChanged,
        onReset,
        mode,
        value,
        formType,
        addCrumb,
        popCrumb
    }: IxProcessPrinterSetupParamInterfaceFormFieldProps,
    ref
) => {
    const fieldAutoUpdateRef = useRef<any>(null)
    const schema = useIxJsonSchema('processPrinterSetupParamInterface')

    const [fmvIndex, setFmvIndex] = useState(0)

    const showSubForm = useCallback(() => {
        setFmvIndex(1)
    }, [])

    const hideSubForm = useCallback(() => {
        setFmvIndex(0)
    }, [])



    const [initialValues, setInitialValues] = useState(_initialValues)

    useEffect(() => {
        setInitialValues({ ..._initialValues, ...value })
    }, [value])

    const formik = useMemo(() => ({
        initialValues: initialValues,
        enableReinitialize: true,
        jsonSchema: schema,
        avjOptions: {
            coerceTypes: true,
            $data: true,
        },
        onSubmit: async (values: any, { setSubmitting }: any) => {
            setSubmitting(true)

            const processPrinterSetupParamInterface = { ...values }

            onSubmit(processPrinterSetupParamInterface)
            setSubmitting(false)
        }
    }), [schema, onSubmit, initialValues])

    useImperativeHandle(ref, () => ({
        setValues: (values: any) => {
            fieldAutoUpdateRef.current?.setValues(values)
        }
    }), [])

    useEffect(() => {
        if (active) {
            addCrumb && addCrumb(label)
            return () => popCrumb && popCrumb()
        }
    }, [active, label, addCrumb, popCrumb])

    // show loading indicator while json schema is fetched
    if (!schema) {
        return (<Spinner />)
    }

    return (
        <MultiView
            selectedIndex={ fmvIndex }
            deferRendering={ false }
            swipeEnabled={ false }
        >
            <MVItem>
                <BaseForm {...formik}>
                    <IxLookupProvider>
                        <IxFormFieldAutoUpdate
                            ref={ fieldAutoUpdateRef }
                            active={ active }
                            // loadingEnabled={ loadingEnabled && fmvIndex === 0 }
                            onValueChanged={ onValueChanged }
                            onReset={ onReset }
                            // mode={ mode }
                            // formType={ formType }
                        />
                        <AutoUpdateForm
                            pageName=''
                            formMode={ mode }
                            active={ active }
                            setInitialValues={ setInitialValues }
                        />
                        <IxProcessPrinterSetupParamInterfaceFormContent
                            active={ active }
                            loadingEnabled={ loadingEnabled && fmvIndex === 0 }
                            pageName=''

                            formMode={ mode }
                            formType={ formType }

                            onReset={ onReset }

                            showSubForm={ showSubForm }
                            hideSubForm={ hideSubForm }

                            addCrumb={ addCrumb }
                            popCrumb={ popCrumb }


                            moduleRight={ IxModuleRights.All }
                            hasPrinterBtns={hasPrinterBtns}
                            availableResultActions={availableResultActions}
                        />
                    </IxLookupProvider>
                </BaseForm>
            </MVItem>
            <MVItem>
                <div id='processPrinterSetupParamInterface-portal'></div>
            </MVItem>
        </MultiView>
    )
})

export default IxProcessPrinterSetupParamInterfaceForm